var map = {
	"./minicipiosBahia": [
		"QxNn",
		6
	],
	"./minicipiosBahia.json": [
		"QxNn",
		6
	],
	"./municipiosAmapa": [
		"JNqm",
		5
	],
	"./municipiosAmapa.json": [
		"JNqm",
		5
	],
	"./municipiosDefault": [
		"UTSS",
		4
	],
	"./municipiosDefault.json": [
		"UTSS",
		4
	],
	"./municipiosMaranhao": [
		"vro7",
		3
	],
	"./municipiosMaranhao.json": [
		"vro7",
		3
	],
	"./municipiosPara": [
		"VZKQ",
		2
	],
	"./municipiosPara.json": [
		"VZKQ",
		2
	],
	"./municipiosRoraima": [
		"ZIwk",
		1
	],
	"./municipiosRoraima.json": [
		"ZIwk",
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "9IJZ";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./static/seeds lazy ^\.\/.*$
// module id = 9IJZ
// module chunks = 11